<!-- 
	This is the main page of the application, the layout component is used here,
	and the router-view is passed to it.
	Layout component is dynamically declared based on the layout for each route,
	specified in routes list router/index.js .
 -->

<template>
	<div id="app">
		<component :is="layout">
			<router-view />
		</component>
	</div>
</template>

<script>

	export default ({
        created() {
            if(localStorage.getItem('mtoken')) {
                this.$store.dispatch('getInfo');
            }

            this.$store.commit('changeLang', localStorage.getItem('lang'));
        },
		computed: {
			// Sets components name based on current route's specified layout, defaults to
			// <layout-default></layout-default> component.
			layout() {
				return "layout-" + ( this.$route.meta.layout || "default" ).toLowerCase();
			}
		},
	})
</script>

<style lang="scss">
    .page_loading {
        text-align: center;
        padding: 100px 0 0;
    }
    .table_btn {
        min-width: 116px;
        height: 40px !important;
        font-size: 14px !important;
    }
</style>
